import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import useDropdown from "../../../../hooks/dropdown.hook";
import styles from "./index.module.scss";

export const DateFilterDropdown = () => {
  const [selectedOption, setSelectedOption] = useState("Last 30 Days");
  const { isOpen, setIsOpen, refBtn, refMenu } = useDropdown({});

  const dropdownOptions = [
    { id: "30days", label: "Last 30 Days" },
    { id: "90days", label: "Last 90 Days" },
    { id: "custom", label: "Custom Date", isAlert: true },
  ];

  const handleOptionClick = (label) => {
    setSelectedOption(label);
    setIsOpen(false);
  };

  return (
    <Dropdown
      show={isOpen}
      onToggle={() => setIsOpen(!isOpen)}
      className={styles.dateFilterDropdown}
    >
      <Dropdown.Toggle ref={refBtn} className={styles.dateFilterToggle}>
        {selectedOption}
      </Dropdown.Toggle>
      <Dropdown.Menu ref={refMenu} className={styles.dateFilterMenu}>
        {dropdownOptions.map((option) => (
          <Dropdown.Item
            key={option.id}
            className={`${styles.dateFilterItem} ${
              option.isAlert ? styles.dateFilterItemAlert : ""
            } ${selectedOption === option.label ? styles.dateFilterItemSelected : ""}`}
            onClick={() => handleOptionClick(option.label)}
          >
            <span
              className={`${styles.dateFilterItemText} ${
                option.isAlert ? styles.dateFilterItemTextAlert : ""
              }`}
            >
              {option.label}
            </span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};